<template>
  <button
    type="button"
    @click="handleClick"
    :class="`${className} ${plus ? 'plus' : ''}`"
    :style="
      `fontSize:${fontSize}px;width:${width}px;height:${height}px;borderRadius:${radius}px;cursor: pointer;paddingLeft:${
        plus ? '15px' : '0'
      };fontWeight:${fontWeight}`
    "
  >
    <i v-if="plus"></i>{{ btnText }}
    <br />
    <span v-if="subText !== ''" class="subText">{{ subText }}</span>
  </button>
</template>

<script>
export default {
  props: {
    btnText: {
      type: String,
      default: ""
    },
    fontSize: {
      type: Number,
      default: 14
    },
    className: {
      type: String,
      default: "primary"
    },
    width: {
      type: Number
    },
    height: {
      type: Number,
      default: 41
    },
    radius: {
      type: Number,
      default: 20.5
    },
    plus: {
      type: Boolean,
      default: false
    },
    fontWeight: {
      type: Number,
      default: 500
    },
    subText: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClick() {
      this.$emit("handleClick");
    }
  }
};
</script>

<style lang="scss" scoped>
.primary {
  background: #3a61b1;
  color: #fff;
  border: 0;
}
.primary_plain {
  border: 1px solid #3a61b1;
  background: none;
  color: #3a61b1;
}
.default {
  background: #fff;
  border: 1px solid #dddddd;
}
.plus {
  i {
    position: relative;
    &::before {
      content: "";
      border-bottom: 2px solid #3a61b1;
      background: #bdc9e3;
      width: 12px;
      position: absolute;
      right: 5px;
      top: 9px;
    }
    &::after {
      content: "";
      border-left: 2px solid #3a61b1;
      width: 12px;
      height: 12px;
      position: absolute;
      right: -2px;
      top: 4px;
    }
  }
}
.subText {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Btn.vue